
export const defaultDelay = 250
export function clickDelay(msec: number, fx: (...args: any[]) => void) {
    return function(...args: any[]) {
        setTimeout(() => {
            fx(...args)
        }, msec)
    }
}